import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );

export default function animations(list) {
	list.forEach(({selector, from, to}) => {
		if(from && to){
			gsap.fromTo(selector, from, to)
		}else if(from){
			gsap.from(selector, from)
		}else if(to){
			gsap.to(selector, to)
		}
	})
}